export const GET_CATEGORY = "GET_CATGEGORY";
